module.exports = __webpack_public_path__ + "img/bd(1).c82c7dcc.webp";